import React from 'react';
import get from 'lodash/get';
import AddToGroupIcon from '../../../Icons/AddToGroup';
import SplitStatLayout from '../StatLayout/SplitStatLayout';
import { useFlag } from '../../../redux/flags/hooks/useFlag';
export var GroupStat = function (_a) {
    var deviation = _a.deviation, isGroupsPanelOpen = _a.isGroupsPanelOpen, onClick = _a.onClick, actionBarType = _a.actionBarType;
    var spacingExperiment = useFlag('actionbar_spacing');
    var isExtendedLoaded = !!deviation.extended;
    return (React.createElement(SplitStatLayout, { icon: AddToGroupIcon, hasValue: true, onClick: function () { return onClick(actionBarType); }, tooltip: isGroupsPanelOpen ? undefined : { tooltipKey: 'actionbar.addToGroup' }, value: get(deviation, 'extended.stats.groups', spacingExperiment && !isExtendedLoaded ? undefined : 0) }));
};
GroupStat.displayName = 'GroupStat';
export default GroupStat;
//# sourceMappingURL=GroupStat.js.map